// libs
import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckmarkCircleOutlineLegacy, EyeOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
// components
import { Box, Button, Checkbox } from '@lyearn/ui';

// types
import { ScorecardFragment } from '../../graphql/fragments/generated/Scorecard';
import Scorecard from '../Scorecard';
// style
import { scorecardSelectorStyles } from './style';

function ScorecardViewer({
  scorecard,
  className,
  onToggle,
  isSelected,
  onPreview,
  actionMenu,
}: {
  scorecard: ScorecardFragment;
  className?: string;
  onToggle?: (scorecardId: string) => void;
  isSelected?: boolean;
  onPreview?: (scorecard: ScorecardFragment | null) => void;
  actionMenu?: React.ReactNode;
}) {
  const { t } = useTranslation();
  const _onPreview = useCallback(
    () => (onPreview ? onPreview(scorecard) : undefined),
    [onPreview, scorecard],
  );

  return (
    <Scorecard.Provider
      className={cn(
        'flex items-center justify-between rounded-8 border border-solid border-border p-20',
        className,
        scorecardSelectorStyles,
      )}
      scorecard={scorecard}>
      <Box className="truncate">
        <Scorecard.Name />
        <Box className="mt-8 flex">
          <Box className="flex flex-shrink-0 items-center me-12">
            <CheckmarkCircleOutlineLegacy className="h-16 w-16 flex-shrink-0 fill-current text-text-placeholder me-4" />
            <Scorecard.TotalQuestions />
          </Box>
          <Scorecard.SkillName />
          {onPreview ? (
            <Button
              className="preview-btn transition-300 h-auto pt-0 pb-0 text-bg-accent transition"
              data-attr="PREVIEW"
              startIcon={<EyeOutline className="fill-current" />}
              variant="ghost"
              onClick={_onPreview}>
              {t('Common:Actions.Preview')}
            </Button>
          ) : null}
        </Box>
      </Box>
      {onToggle ? (
        <Checkbox
          checked={isSelected}
          data-attr="SELECT"
          data-id={scorecard.id}
          onClick={() => onToggle(scorecard.id)}
        />
      ) : null}
      {actionMenu}
    </Scorecard.Provider>
  );
}

export default ScorecardViewer;
